// Shared table styling for the Briefs queue tabs.
//
// The four tabs grew separately and each invented its own table: WaitingOnYou
// used a real <table> with bg-table-header and px-4/py-2.5 headers;
// BriefsOverdueList used a CSS grid with px-5/py-3 and no header tint;
// FeedbackDueList used a <table> with untinted headers and its own min-width.
// Switching tabs therefore shifted the column gutters, the header weight and
// the row height, which reads as three different screens rather than one view
// with four filters.
//
// These are the tokens, not the markup — BriefsOverdueList keeps its CSS grid
// because it wants fixed column widths, but it uses the same paddings, header
// treatment and hairlines as the real tables, so the tabs line up visually.
//
// Change a value here, not at a call site. See [[one-helper-dedup]].

export const QUEUE_FONT = "font-['Metropolis']";

// Outer container. overflow-hidden keeps the rounded corners over a full-bleed
// header row.
export const QUEUE_SHELL = 'bg-white border border-line rounded-xl overflow-hidden';

// Wrap the table when columns can't compress any further. Horizontal scroll
// belongs to the table, never the page.
export const QUEUE_SCROLL = 'overflow-x-auto';

export const QUEUE_TABLE = 'w-full border-collapse';

// Header band — tinted, with a hairline under it.
export const QUEUE_THEAD = 'bg-table-header border-b border-hair-admin';
// Header TYPOGRAPHY on its own — for grid layouts, where the padding lives on
// the row rather than the cell.
export const QUEUE_TH_TEXT = "font-['Metropolis'] text-[10px] font-bold uppercase tracking-[0.18em] text-fusion-mid-grey";
export const QUEUE_TH = `${QUEUE_TH_TEXT} text-left px-4 py-2.5`;

// Header CELL chrome without the typography — for the List view, whose header
// cells contain their own controls (filter dropdowns, sort buttons) that carry
// their own type. Same tint, hairline and padding as QUEUE_TH so the header
// band lines up across every tab; pair with a width class at the call site.
export const QUEUE_TH_CELL = 'text-left px-4 py-2.5 bg-table-header border-b border-hair-admin';

// Body cells. align-top so a wrapping name doesn't drag its row's other
// columns to the vertical middle.
export const QUEUE_TD = 'px-4 py-3 align-top';

// Row separator + hover. Applied to <tr> or to a grid row alike.
export const QUEUE_ROW = 'border-t border-hair-admin hover:bg-[#F7F9F0] transition-colors';

// Same padding rhythm as QUEUE_TH / QUEUE_TD, for grid-based rows.
export const QUEUE_GRID_HEAD = 'px-4 py-2.5 bg-table-header border-b border-hair-admin';
export const QUEUE_GRID_ROW = 'px-4 py-3 border-t border-hair-admin hover:bg-[#F7F9F0] transition-colors';
// Variant for the zebra-striped grid, which supplies its own row background
// and so needs the divider/hover tokens without a hardcoded hover colour.
export const QUEUE_GRID_ROW_INNER = 'px-4 py-3 border-t border-table-divider hover:bg-table-hover transition-colors';

// Empty state, shared so "nothing here" looks the same on every tab.
export const QUEUE_EMPTY = 'bg-white border border-line rounded-xl px-5 py-10 text-center';
